import { render, staticRenderFns } from "./industryClassManagement.vue?vue&type=template&id=01c32907"
import script from "./industryClassManagement.vue?vue&type=script&lang=js"
export * from "./industryClassManagement.vue?vue&type=script&lang=js"
import style0 from "./industryClassManagement.vue?vue&type=style&index=0&id=01c32907&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports